/**
 * Long-form competitor guides that used to be blog posts and now live on the matching
 * `/<competitor>-alternative` comparison page, so there is exactly one page per competitor query.
 * Blog slug -> comparison page path slug. Published slugs also get a 301 (see src/redirects.ts).
 */
export const MERGED_GUIDES: Record<string, string> = {
  'shipday-alternative-when-to-upgrade-delivery-software': 'shipday-alternative',
  'routific-alternative-from-route-planning-to-logistics-execution': 'routific-alternative',
  'locus-alternatives-from-routing-to-logistics-automation-platforms': 'locus-alternative',
  'onfleet-alternative-how-to-choose-last-mile-platform': 'onfleet-alternative',
  'circuit-for-teams-vs-fleet-scale-dispatch': 'circuit-alternative',
  'bringg-orchestration-vs-execution-first-dispatch': 'bringg-alternative',
  'tookan-alternative-scaling-beyond-task-dispatch': 'tookan-alternative',
  'optimoroute-alternative-beyond-route-scheduling': 'optimoroute-alternative',
  'route4me-alternative-unified-vs-modular-platform': 'route4me-alternative',
  'detrack-alternative-beyond-proof-of-delivery': 'detrack-alternative',
};
